import React, { memo } from 'react';
import { IconArrowRight05 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg/index';
import * as S from './style';

interface IProps {
  catePath?: any[];
  items?: React.ReactNode;
}

const FltDptCategoryList = ({ catePath, items }: IProps) => (
  <S.FltDptCategoryList>
    {catePath && catePath?.length > 0 && (
      <ol className="path">
        {catePath?.map((v: any, i: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={i} className="item">
            {i > 0 && (
              <em className="icon">
                <IconArrowRight05 />
              </em>
            )}
            {v.label}
          </li>
        ))}
      </ol>
    )}
    {items && <ul className="list">{items}</ul>}
  </S.FltDptCategoryList>
);
export default memo(FltDptCategoryList);
